<template>
    <div class="container box">
    
        <div class="">
            <div class="">
                <!-- <div class="columns is-mobile head1 is-gant border-radius">
                    <div class="column has-text-centered">
                        <h1 class="title is-4 has-text-white">
                            <b-icon :icon="icon" /> {{ title }}
                        </h1>
                    </div>
                </div> -->
                <h1 class="is-size-4 mt-3">{{ title }}</h1>
                <div class="py-5">
                    <slot></slot>
                    <b-button @click="$emit('save')" size="is-medium" type="is-gant" class="mt-2">
                        <span class="is-flex"> Save {{ title }}</span>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
    }
};
</script>

<style scoped>
.border-radius {
    border-radius: 5px;
}
</style>
  